// Styles
import '../scss/index.scss';
import '/vendor/pages-v2/index';

$(document).ready(function () {
  $('.drop-categories__btn').on('click', function () {
    $('.header-categories__dropmenu').slideToggle();
  });

  // Mobile menu toggle
  $('.mobile-menu-btn').on('click', function () {
    $('.main-nav').addClass('active');
    $('body').addClass('menu-open');
  });

  $('.nav-close-btn').on('click', function () {
    $('.main-nav').removeClass('active');
    $('body').removeClass('menu-open');
  });

  // Close menu on link click
  $('.main-nav .nav-link').on('click', function () {
    $('.main-nav').removeClass('active');
    $('body').removeClass('menu-open');
  });
});
